// extracted by mini-css-extract-plugin
export default {"tx":"_9ea1778072","line":"_64c32eed78"};